import Settings from '@/services/Rest/Settings';

export default {
	state: {},
	actions: {
		editMyAccount({ commit, dispatch }) {
			return Settings.editMyAccount();
		},
		updateMyAccount({ commit, dispatch }, data) {
			return Settings.updateMyAccount(data);
		}
	},
	mutations: {},
	getters: {}
};
